//@flow
import DeviceInfo from './DeviceInfo';
import getCookie from './getCookie';

/**
 * Parse device header.
 * @param {string} deviceHeader - plain cookies as string
 * @param {Function} onError - handles parsing error
 * @returns  {DeviceInfo}   The device info extracted from the cookie.
 */
export const createDeviceInfoFromHeader = (deviceHeader: string, onError: Error => void) => {
    const deviceInfo = new DeviceInfo();
    try {
        if (deviceHeader) {
            deviceInfo.setup(JSON.parse(deviceHeader));
        }
    } catch (e) {
        onError(e);
    }
    return deviceInfo;
};
/**
 * Unserialise the cookie.
 * @param {string} cookies - plain cookies as string
 * @param {Function} onError - handles parsing error
 * @returns  {DeviceInfo}   The device info extracted from the cookie.
 */
export const createDeviceInfoFromCookies = (cookies: string, onError: Error => void) => {
    const deviceInfo = new DeviceInfo();
    try {
        const whDevice = getCookie(cookies)('wh_device');
        if (whDevice) {
            deviceInfo.setup(JSON.parse(whDevice));
        }
    } catch (e) {
        onError(e);
    }
    return deviceInfo;
};
/**
 * Logs errors to console
 * @param {Error} e - an error result of parsing the cookies to data.
 * @returns {void}
 */
const logDeviceError = (e: Error) => console.log('DeviceInfo: ', e);

let savedDeviceInfo = null;

/**
 * Make it happen!
 *
 * @returns  {DeviceInfo}   The device info extracted from the cookie.
 */
const getDeviceInfo = () => {
    if (savedDeviceInfo === null) {
        savedDeviceInfo = createDeviceInfoFromCookies(window.document.cookie, logDeviceError);
    }
    return savedDeviceInfo;
};

export default getDeviceInfo;
